<template>
  <section :class='cssClass'>
    <div class='title'>{{ title }}</div>
    <div v-if='note' class='note'>{{ note }}</div>
    <button
      v-if='button'
      @click='emit("button:click")'
    >
      {{ button }}
    </button>
  </section>
</template>

<script>
export default {
  name: 'NothingFound',
  inheritAttrs: false
};
</script>

<script setup>
import { t } from '@/helpers/i18n';

const props = defineProps({
  cssClass: { type: String, required: false, default: undefined },
  title: { type: String, required: true },
  note: { type: String, required: true },
  button: { type: String, required: false, default: undefined }
});
const i18n = t(props.i18nKey);

const emit = defineEmits(['button:click']);
</script>

<style scoped lang='sass'>
@import 'app/packs/stylesheets/functions/rem'
@import 'app/packs/stylesheets/mixins/responsive'
@import 'app/packs/stylesheets/mixins/typography'
@import 'app/packs/stylesheets/mixins/button_v4'

section
  align-items: center
  display: flex
  flex-direction: column
  flex-grow: 1
  justify-content: center
  text-align: center

  +lte_ipad
    gap: rem4(8px) !important
    padding: 0 rem4(24px)

  +gte_laptop
    gap: 8px !important
    padding: 0 24px

.title
  color: #000

  +lte_ipad
    +p2(700)

  +gte_laptop
    +h4

.note
  color: var(--gray-600)

  +lte_ipad
    +p4

  +gte_laptop
    +p3

button
  +button_v4('secondary', 'md')

  +lte_ipad
    margin-bottom: rem4(8px)

  +gte_laptop
    margin-bottom: 8px
</style>
